import { render } from "./PaginaPrincipal.vue?vue&type=template&id=19f1e308&scoped=true"
import script from "./PaginaPrincipal.vue?vue&type=script&lang=js"
export * from "./PaginaPrincipal.vue?vue&type=script&lang=js"

import "./PaginaPrincipal.vue?vue&type=style&index=0&id=19f1e308&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f1e308"]])

export default __exports__